"use strict";

($dt => {

	$dt.autostart.push(() => {
		$dt.OnDevelformsReady($df => {
			$df.RegisterFormPreparedEvent('register', form => {
				form.success = resp => {
					// Transitions form using default simple methods
					form.simpleSuccess(resp);

					// Redirect
					if (resp.redirect) {
						setTimeout(() => {
							window.location.href = resp.redirect;
						}, 2500);
					}
				};
			});
		});
	});
		
})(window.d3_wp_themejs);
